module.exports = {
    HOST:
        process.env.NODE_ENV !== 'production'
            ? 'http://localhost:4024/api'      // Development server URL
            : 'https://server.nadaqueleer.com/api' // Production server URL
};